/**
 * Created by Yoyo Fang on 06/12/2020.
 * Description:
 *
 * ------ maintenance history ------
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AgGridModule } from 'ag-grid-angular';
import { AaclTreeListModule } from 'aacl-tree-list';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';


import { WidgetsModule } from '../../../widgets/widgets.module';
import { IntralinksComponent } from './intralinks.component';
import { IntralinksFolderComponent } from '../../../components/intralinks-folder/intralinks-folder.component';
import { IntralinksFolderActionsComponent } from '../../../components/intralinks-folder/intralinks-folder-actions.component';
import { IntralinksFolderNameComponent } from '../../../components/intralinks-folder/intralinks-folder-name.component';
import { IntralinksGroupContainerComponent } from '../../../components/intralinks-group/intralinks-group-container.component';
import { IntralinksGroupComponent } from '../../../components/intralinks-group/intralinks-group.component';
import { IntralinksRoutingModule } from './intralinks-routing.module';
import { IntralinksContentContainerComponent } from '../../../components/intralinks-content-container/intralinks-content-container.component';
import { IntralinksValidationComponent } from '../../../components/intralinks-validation/intralinks-validation.component';

@NgModule({
    imports: [
        AgGridModule,
        CommonModule,
        WidgetsModule,
        DropDownsModule,
        AaclTreeListModule,
        IntralinksRoutingModule
    ],
    declarations: [
        IntralinksValidationComponent,
        IntralinksFolderNameComponent,
        IntralinksFolderActionsComponent,
        IntralinksFolderComponent,
        IntralinksGroupComponent,
        IntralinksGroupContainerComponent,
        IntralinksContentContainerComponent,
        IntralinksComponent,
    ],
    exports: [
        IntralinksComponent,
    ]
})
export class IntralinksModule { }
